module.exports = __webpack_public_path__ + "static/media/summaryDashboard.a8f2619a.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/feature/summaryDashboard.gif
 ** module id = 614
 ** module chunks = 0
 **/